export default "__VITE_ASSET__e0861a9f__"